import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { View } from './components/View';

const widgetsBreadCrumbs: Array<PageLink> = [];

const BoxDeliveryPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>Iniciar día y caja</PageTitle>
      <View />
    </>
  );
};

export { BoxDeliveryPage };
